<div
	@fadeInOut
	*ngIf="!listSize && emptyListMessage?.length && !hideEmptyList"
	class="row mx-0"
>
	<div class="col-12 px-3 px-md-0 empty-list">
		<div class="card text-center px-3">
			{{ emptyListMessage }}
		</div>
	</div>
</div>
